import { jsx as _jsx } from "react/jsx-runtime";
import { BaseTreeTable } from './BaseTreeTable';
import { useTranslation } from 'react-i18next';
export default function OrderStatusTreeTable({ treeData, expandedKeys, onToggle, onCellClick, loading = false, showExpander = true, tableClassName, }) {
    const { t } = useTranslation();
    const translatedData = treeData.map((vehicle, index) => {
        var _a;
        return ({
            key: index.toString(),
            data: {
                name: vehicle.vehicleLine,
                unscheduled: vehicle.unscheduled,
                inSystem: vehicle.inSystem,
                inTransit: vehicle.inTransit,
                stock: vehicle.stock,
                total: vehicle.total,
                isParent: true,
                parentLine: vehicle.vehicleLine,
                code: vehicle.ptvlCode,
            },
            children: (_a = vehicle.modelYears) === null || _a === void 0 ? void 0 : _a.map((modelYear, yearIndex) => ({
                key: `${index}-${yearIndex}`,
                data: {
                    name: modelYear.year,
                    unscheduled: modelYear.unscheduled,
                    inSystem: modelYear.inSystem,
                    inTransit: modelYear.inTransit,
                    stock: modelYear.stock,
                    total: modelYear.total,
                    isParent: false,
                    parentLine: vehicle.vehicleLine,
                    code: vehicle.ptvlCode,
                },
            })),
        });
    });
    const linkTemplate = (node, field) => {
        var _a, _b;
        const val = node.data[field];
        const isParent = node.data['isParent'];
        const vehicleLine = (_b = (_a = node.data['code']) !== null && _a !== void 0 ? _a : node.data['parentLine']) !== null && _b !== void 0 ? _b : node.data['name'];
        const modelYear = isParent ? undefined : node.data['name'];
        return (_jsx("button", { onClick: val !== 0 && field !== 'stock' ? () => onCellClick(vehicleLine, field, val, modelYear) : undefined, className: val !== 0 && field !== 'stock' ? 'link-btn' : 'zero-count-btn', children: val }));
    };
    const columns = [
        ...(showExpander
            ? [{
                    field: 'expand',
                    header: '',
                    expander: true,
                    headerClassName: 'expander-header',
                    className: 'expander-cell',
                }]
            : []),
        {
            field: 'name',
            header: t('vehicleLine'),
            headerClassName: 'vehicle-line-header',
        },
        {
            field: 'unscheduled',
            header: t('unscheduled'),
            body: (node) => linkTemplate(node, 'unscheduled'),
            headerClassName: 'col-unscheduled-header',
        },
        {
            field: 'inSystem',
            header: t('inSystem'),
            body: (node) => linkTemplate(node, 'inSystem'),
            headerClassName: 'col-status-header',
        },
        {
            field: 'inTransit',
            header: t('inTransit'),
            body: (node) => linkTemplate(node, 'inTransit'),
            headerClassName: 'col-status-header',
        },
        {
            field: 'stock',
            header: t('stockStatus') + "*",
            body: (node) => linkTemplate(node, 'stock'),
            headerClassName: 'col-status-header',
        },
        {
            field: 'total',
            header: t('total'),
            body: (node) => linkTemplate(node, 'total'),
            headerClassName: 'col-status-header',
        },
    ];
    return (_jsx(BaseTreeTable, { value: translatedData, columns: columns, expandedKeys: expandedKeys, onToggle: onToggle, loading: loading, className: tableClassName }));
}
